var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "app-browse",
        {
          attrs: {
            "data-source": _vm.dataSource,
            "selected-items": _vm.selectedItems,
            "controls-disabled": _vm.controlsDisabled,
            "button-bar-items": _vm.buttonBarItems,
            "search-enabled": _vm.searchEnabled,
            "url-query-params": "",
            "context-menu-items": _vm.contextMenuItems,
          },
          on: {
            createManualFrequencyDocuments: function ($event) {
              return _vm.createManualFrequencyDocuments()
            },
            removeMollieMandate: function ($event) {
              return _vm.removeMollieMandate($event)
            },
            stopFrequencyDocument: function ($event) {
              return _vm.stopFrequencyDocument($event)
            },
            state: function ($event) {
              _vm.browseState = $event
            },
          },
        },
        [
          _vm._t("header", null, { slot: "header" }),
          _vm._t("extra-buttons", null, { slot: "extra-buttons" }),
          _vm._t("top", null, { slot: "top" }),
          _vm._t("bottom", null, { slot: "bottom" }),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          staticClass: "w100",
          attrs: {
            value: _vm.$route.path != "/subscriptions",
            "escape-close": "",
            "full-height": "",
          },
        },
        [
          _c("router-view", {
            key: _vm.$route.path,
            on: {
              "created-new-doc": function ($event) {
                return _vm.updateView()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }